module.exports = __webpack_public_path__ + "img/Frame 212_copy1.d789e4f0.png";